import Profiles from "components/Profiles";
import Main from "layouts/Main";


function ProfilePage() {

  return (
    <>
    <Main namePage="โปรไฟล์"  >
      <div className="layout-content">
        <Profiles />
      </div>
      </Main>
    </>
  );
}

export default ProfilePage;